import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import Immutable from 'immutable';

// @ts-expect-error Untyped Dependency
import AgentResponseTimeoutMiddleware from './email-capture/middleware/AgentResponseTimeoutMiddleware';
// @ts-expect-error Untyped Dependency
import VisitorLastSeenMiddleware from './last-seen/middleware/VisitorLastSeenMiddleware';
// @ts-expect-error Untyped Dependency
import VisitorNotificationMiddleware from './middleware/VisitorNotificationMiddleware';
// @ts-expect-error Untyped Dependency
import { visitorErrorMiddleware } from './error-reporting/middleware/visitorErrorMiddleware';
// @ts-expect-error Untyped Dependency
import { realtime } from './pubsub/middleware/realtime';
import { INITIALIZE_PUBSUB } from './pubsub/constants/asyncActionTypes';
import visitorUIRootReducer from './reducers/visitorUIRootReducer';
import { useDispatch, useSelector } from 'react-redux';
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
export default function buildStore(preloadedState, extraArgs) {
  const middleware = [thunk.withExtraArgument(extraArgs), visitorErrorMiddleware, VisitorLastSeenMiddleware, VisitorNotificationMiddleware, AgentResponseTimeoutMiddleware, realtime];
  return configureStore({
    reducer: visitorUIRootReducer,
    preloadedState,
    middleware,
    devTools: {
      maxAge: 200,
      serialize: {
        options: {
          // @ts-expect-error Unknown type
          circular: '[CIRCULAR]'
        },
        immutable: Immutable
      },
      // Ably's client is quite large and serializing it slows down redux devtools
      actionSanitizer: action => {
        if (action.type === INITIALIZE_PUBSUB.SUCCEEDED) {
          return Object.assign({}, action, {
            payload: {
              client: '<< PUBSUB CLIENT >>'
            }
          });
        }
        return action;
      },
      stateSanitizer: state => {
        if (state.pubSubClient.data) {
          return Object.assign({}, state, {
            pubSubClient: state.pubSubClient.set('data', '<< PUBSUB CLIENT >>')
          });
        }
        return state;
      }
    }
  });
}